import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

/**
 * Auth Context'i kullanmak için custom hook
 * @throws Error - AuthProvider olmadan kullanılırsa hata fırlatır
 */
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth hook\'u AuthProvider içinde kullanılmalıdır');
  }

  return context;
};
